import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { HubConnection } from '@microsoft/signalr';
import { SnackbarService } from './snackbar.sevice';

@Injectable({
    providedIn: 'root'
})
export class SignalRService {
    constructor(private readonly snackbarService: SnackbarService) {}

    public createHubConnection(hubUri: string, onReconnectedFn: () => void): HubConnection {
        const hubConnection = new signalR.HubConnectionBuilder().withUrl(hubUri).withAutomaticReconnect().build();

        hubConnection.onreconnecting(error => {
            this.snackbarService.openSnackBar(`Connection lost. Reconnecting.`, SnackbarService.SNACK_BAR_CLASS_ALERT);
        });

        hubConnection.onreconnected(() => {
            this.snackbarService.openSnackBar(`Connection reestablished.`, SnackbarService.SNACK_BAR_CLASS_SUCCESS);
            onReconnectedFn();
        });

        return hubConnection;
    }
}
